import {$vfm} from 'vue-final-modal';
import commonFn from '@/commons/commonFunction.js';
import {MSConstant} from '@/commons/wildcards/index.js';
import {showError} from '@/commons/globalMessage';
import {useRoute, useRouter} from 'vue-router';
/**
 * Xử lý hiển thị popup
 */
class PopupUtil {
  /**
   * Đối tượng cache lại các component popup
   */
  _components = {};

  /**
   * Danh sách các popup đang hiển thị
   * key: tên popup
   * value: instance
   */
  _visible = {};

  /**
   * Lưu thông tin ds các popup theo subsystemcode
   */
  _registerPopup = {};

  /**
   * Mở popup
   * @param {string} name : Tên định danh
   * @param {object} params : tham số
   * @param {bool} ignoreCheckPermission : bỏ qua check quyền theo vai trò hay không
   * KHI THÊM THAM SỐ LƯU Ý BỔ SUNG THÊM TRONG CẢ orderPopupStore.js (nvxuan 20.02.2024)
   */
  show(name, params, ignoreCheckPermission, attrs) {
    if (!name) throw 'name is required';
    const ps = params || {};
    ps.name = name;

    // check quyền hạn
    if (!ignoreCheckPermission && !commonFn.checkPermissionForShowPopup(name)) {
      let msg = 'Bạn không có quyền thực hiện chức năng này. Vui lòng kiểm tra lại quyền của bạn.',
        title = 'Không được phân quyền';

      if (params.directFromLocation) {
        useRouter().push({name: '403'});
      } else {
        showError(msg, title);
      }

      throw msg;
    }

    let dynamicModalOptions = {component: name};

    (attrs && typeof attrs == 'object') && (dynamicModalOptions.bind = attrs);

    const popup = $vfm.show(dynamicModalOptions, ps);

    console.log(`Popup name: ${name}`);
    return popup;
  }

  /**
   * Đóng tất cả popup đang mở
   */
  hideAll() {
    $vfm.hideAll();
  }

  /**
   * Ẩn popup
   * @param {*} name
   * @returns
   */
  hide(name) {
    if (!name) throw 'name is required';
    const popup = $vfm.hide(name);

    return popup;
  }

  /**
   * Toggle popup
   * @param {*} name
   * @param {*} toggle
   * @returns
   */
  toggle(name, toggle) {
    if (!name) throw 'name is required';
    const popup = $vfm.toggle(name, toggle);

    return popup;
  }

  /**
   * Lưu lại thông tin phục vụ check quyền hạn khi show popup
   */
  registerPopup(keys, subSystemCode) {
    subSystemCode = subSystemCode.toLowerCase();
    let data = [];
    keys.filter(e => {
      data.push(e.toLowerCase());
    });
    const oldData = this._registerPopup[subSystemCode] || [];
    this._registerPopup[subSystemCode] = [...oldData, ...data].distinctKey();
  }
}

export default new PopupUtil();
